import React from "react";
import { styled } from "@mui/system";
import {
  BORDER_PRIMARY,
  DISPLAY_BLOCK,
} from "../../config/styles";
import { colors } from "../../config/colors";

export const StudentConfigStyled = styled("div")(({ theme }) => ({
  "& .configuration-page": {
    display: DISPLAY_BLOCK,
    backgroundColor: theme.palette.secondary.contrastText,
    margin: "0 128px 0 296px",
    borderRadius: "8px",
    width: "calc(100% - 424px) !important",
    border: BORDER_PRIMARY,
    minWidth: "480px !important",
  },
  "& .configuration-general": {
    margin: "32px 24px 24px 24px",
  },
  "& .configuration-grade-box": {
    borderRadius: "4px",
    backgroundColor: colors.disabled,
    padding: "12px 12px 8px 12px",
    marginTop: "10px",
    width: "380px",
  },
  "& .config-payment-item": {
    margin: "0 0 24px 24px",
  },
}));
